import { create } from 'zustand';

export type ModalState =
  | { kind: 'createGuild' }
  | { kind: 'invite'; channelId: string }
  | { kind: 'guildSettings'; guildId: string }
  | { kind: 'channelSettings'; channelId: string }
  | { kind: 'createChannel'; guildId: string; parentId?: string | null; type?: 0 | 2 | 4 | 15 }
  | { kind: 'createThread'; guildId: string; channelId: string; messageId?: string; name?: string }
  | { kind: 'createPoll'; channelId: string }
  | { kind: 'events'; guildId: string }
  | { kind: 'userSettings' }
  | { kind: 'profile'; userId: string; guildId?: string | null }
  | { kind: 'safety'; channelId: string }
  | null;

export const useUi = create<{ modal: ModalState; showMembers: boolean; navOpen: boolean }>(() => ({
  modal: null,
  showMembers: true,
  /** phones: the slide-over drawer with servers and channels */
  navOpen: false,
}));
export const setNavOpen = (navOpen: boolean) => useUi.setState({ navOpen });
export const openModal = (modal: ModalState) => useUi.setState({ modal });
export const closeModal = () => useUi.setState({ modal: null });
